// Spinner de carga reutilizable. Usa la animacion spin de Tailwind.
export default function Spinner({ label = "Cargando…" }) {
    return (
        <div className="flex flex-col items-center justify-center gap-3 py-12 text-slate-400">
            <span
                className="inline-block h-8 w-8 rounded-full border-[3px] border-slate-200 border-t-cyan-600 animate-spin"
                role="status"
                aria-label="Cargando"
            />
            <span className="text-sm">{label}</span>
        </div>
    );
}